import { conformToMask } from 'react-text-mask';

import * as masks from 'constants/forms-validaition';

export type FormatValueKind = 'phone' | 'date' | string;

export const formatValue = (
  value: string | number,
  format: FormatValueKind
): string | number => {
  switch (format) {
    case 'phone':
      return conformToMask(value.toString(), masks.phone, { guide: false })
        .conformedValue;
    case 'date':
      return conformToMask(value.toString(), masks.mmddyyyy).conformedValue;
    default:
      return value;
  }
};
